import React from 'react';
import { useState, useContext, useEffect } from 'react';
import { StateContext } from '../../StateContainer';
import ImpostazioniDiBase from '../tabmenu/ImpostazioniDiBase';
import InputUtenteWidget from '../tabmenu/InputUtenteWidget';
import GestioneVariabili from '../tabmenu/GestioneVariabili';
import ApiEsterne from '../tabmenu/ApiEsterne';
import GenerazioneOutput from '../tabmenu/GenerazioneOutput';

const NodeModal = () => {
  const modalTabMenu = [
    {
      id: 1,
      title: 'Base',
      section: '#impostazioniBase',
    },
    {
      id: 2,
      title: 'Gestione variabili',
      section: '#gestioneVariabili',
    },
    {
      id: 3,
      title: 'Input utente',
      section: '#inputUtente',
    },
    {
      id: 4,
      title: 'API esterne',
      section: '#apiEsterne',
    },
    {
      id: 5,
      title: 'Generazione output',
      section: '#generazioneOutput',
    },
  ];

  const {
    dettagliNodi,
    setDettagliNodi,
    currentTab,
    setCurrentTab,

    // Selected Node
    selectedNode,
    setSelectedNode,

    // Selected Edge
    selectedEdge,
    setSelectedEdge,

    // Show modal variables
    setShowModalVariables,
  } = useContext(StateContext);

  const selectedNodeId = selectedNode ? parseInt(selectedNode.id) : '';
  const nodoKey = selectedNodeId ? `nodo-${selectedNodeId}` : '';

  const closeModal = () => {
    setSelectedNode(null);
    setShowModalVariables(false);
    setSelectedEdge(null);
  };
  return (
    <div
      className="d-block"
      tabIndex="-1"
      role="dialog"
      style={{
        backgroundColor: '#F0F0F0',
      }}
    >
      <div className="modal-lg d-flex w-100" role="document">
        <div
          className="content-popup p-4"
          style={{
            boxShadow: '0px 0px 20px 5px rgba(0, 0, 0, 0.15)',
            borderRadius: '10px',
            border: '1px solid #888888',
            width: '70%', // Occupa il 90% del contenitore relativo
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
            minHeight: '700px',
            backgroundColor: '#F0F0F0',
            maxHeight: '700px',
          }}
        >
          <div className="" style={{ backgroundColor: '#F0F0F0' }}>
            <div className="d-flex justify-content-between mb-4">
              <div></div>
              <p className="fw-bold">{dettagliNodi[nodoKey]?.node_label}</p>
              <button
                type="button"
                className="btn-close"
                onClick={closeModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="d-flex justify-content-between align-items-center gap-2">
              {modalTabMenu.map((component, index, array) => (
                <React.Fragment key={index}>
                  <button
                    className={`btn px-1 py-2 ${
                      currentTab === component.section
                        ? 'tab-menu-conversational-active '
                        : 'tab-menu-conversational-secondary'
                    }`}
                    style={{ width: '500px' }}
                    onClick={() => setCurrentTab(component.section)}
                  >
                    {component.title}
                  </button>
                  {/* Aggiunge la lineetta solo tra i bottoni */}
                </React.Fragment>
              ))}
            </div>
            <div>
              {currentTab === '#impostazioniBase' ? (
                <ImpostazioniDiBase
                  setCurrentTab={setCurrentTab}
                  closeModal={closeModal}
                  dettagliNodi={dettagliNodi}
                  selectedNode={selectedNode}
                  selectedEdge={selectedEdge} // Passa anche l'edge se selezionato
                  setDettagliNodi={setDettagliNodi}
                />
              ) : currentTab === '#inputUtente' ? (
                <InputUtenteWidget
                  setCurrentTab={setCurrentTab}
                  closeModal={closeModal}
                  dettagliNodi={dettagliNodi}
                  selectedNode={selectedNode}
                  selectedEdge={selectedEdge}
                  setDettagliNodi={setDettagliNodi}
                />
              ) : currentTab === '#gestioneVariabili' ? (
                <GestioneVariabili
                  setCurrentTab={setCurrentTab}
                  closeModal={closeModal}
                  dettagliNodi={dettagliNodi}
                  selectedNode={selectedNode}
                  selectedEdge={selectedEdge}
                  setDettagliNodi={setDettagliNodi}
                />
              ) : currentTab === '#apiEsterne' ? (
                <ApiEsterne
                  setCurrentTab={setCurrentTab}
                  closeModal={closeModal}
                  dettagliNodi={dettagliNodi}
                  selectedNode={selectedNode}
                  selectedEdge={selectedEdge}
                  setDettagliNodi={setDettagliNodi}
                />
              ) : (
                <GenerazioneOutput
                  setCurrentTab={setCurrentTab}
                  closeModal={closeModal}
                  dettagliNodi={dettagliNodi}
                  selectedNode={selectedNode}
                  selectedEdge={selectedEdge}
                  setDettagliNodi={setDettagliNodi}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NodeModal;
